import React from 'react';
import { useAppVersion } from '../hooks/useAppVersion';
import UpdateModal from './UpdateModal';
import { useAuth } from '../contexts/auth.context';

export default function VersionChecker({ children }) {
    const { signed } = useAuth();
    const { showUpdateModal, updateApp, dismissUpdate, currentVersion, versionInfo } = useAppVersion();

    // Só mostra o modal se o usuário estiver logado
    const shouldShowModal = signed && showUpdateModal;

    return (
        <>
            {children}
            <UpdateModal
                open={shouldShowModal}
                onUpdate={updateApp}
                onDismiss={dismissUpdate}
                version={currentVersion}
                versionInfo={versionInfo}
            />
        </>
    );
}
